import { Dispatch } from 'react'
import { IActionGeneric, IFilters, ISort } from 'core/actions/Actions.interfaces'
import { defaultListParams } from 'core/utils/constants'
import HTTPClient from 'core/services/HTTPClient'
import { IErrorData } from 'core/utils/interfaces'
import HTTPUrlHelper from 'shared/helpers/HTTPUrlHelper'
import { AuditLogEventActions } from './AuditLogs.constants'
import { IAuditLogsEvent, IAuditLogsEventState } from './AuditLogs.types'
import { actionCoreApi } from 'core/utils/api'
import ActionsList from 'core/actions/Actions.list'

export function fetchAuditEvents (params: ISort = defaultListParams, filters?: IFilters): (dispatch: Dispatch<IActionGeneric<AuditLogEventActions>>) => Promise<IAuditLogsEventState | IErrorData> {
  return async (dispatch: Dispatch<IActionGeneric<AuditLogEventActions>>): Promise<IAuditLogsEventState | IErrorData> => {
    dispatch({ type: AuditLogEventActions.FetchAuditEventsRequest })
    const URL: string = HTTPUrlHelper.getFilteredAPI(HTTPUrlHelper.getAuditEventsAPI(), params, filters)
    const { data, status } = await HTTPClient.GET(URL)

    if (data && status === 200) {
      dispatch({ type: AuditLogEventActions.FetchAuditEventsSuccess,
        payload: data
      })
    }

    if (data.error) {
      dispatch({ type: AuditLogEventActions.FetchAuditEventsFailure })
    }

    return data
  }
}

export function fetchAuditEvent (id: string): (dispatch: Dispatch<IActionGeneric<AuditLogEventActions>>) => Promise<IAuditLogsEvent> {
  return async (dispatch: Dispatch<IActionGeneric<AuditLogEventActions>>): Promise<IAuditLogsEvent> => {
    dispatch({ type: AuditLogEventActions.FetchAuditEventRequest })
    const URL = HTTPUrlHelper.getAuditEventsAPI()
    const { data, status } = await HTTPClient.GET(`${URL}/${id}`)

    if (data && status === 200) {
      dispatch({ type: AuditLogEventActions.FetchAuditEventSuccess,
        payload: data
      })
      return data
    }
    dispatch({ type: AuditLogEventActions.FetchAuditEventFailure })
    throw new Error(data)
  }
}

export const checkDataIntegrity = (id: string): ActionType =>
actionCoreApi(
  ActionsList.VerifyAuditLogIntegrity,
  HTTPUrlHelper.verifyAuditLogAPI(id),
  'GET'
)